import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuthStore, useUIStore } from "./context/store.js";
import { useSocket } from "./hooks/useSocket.js";
import AppShell  from "./pages/AppShell.jsx";
import AuthPage  from "./pages/AuthPage.jsx";
import "./index.css";

function AuthGuard({ children }) {
  const { user, token, fetchMe } = useAuthStore();
  useEffect(() => { if (token && !user) fetchMe(); }, [token]);
  if (!token) return <Navigate to="/login" replace />;
  if (!user)  return <div style={{ display:"flex",alignItems:"center",justifyContent:"center",height:"100vh",background:"#08070F" }}><div className="vyl-spinner" /></div>;
  return children;
}

function Toast() {
  const toast = useUIStore(s => s.toast);
  if (!toast) return null;
  const colors = { success: "#10F5A0", error: "#FF6B6B", info: "#38BDF8" };
  return (
    <div style={{
      position: "fixed", bottom: 90, left: "50%", transform: "translateX(-50%)",
      zIndex: 9999, background: "#131124", border: `1px solid ${colors[toast.type] || colors.info}40`,
      borderRadius: 12, padding: "12px 20px", color: "#F0EFFE", fontSize: 14, fontWeight: 600,
      boxShadow: `0 8px 32px ${colors[toast.type] || colors.info}30`,
      animation: "slide-up 0.3s ease",
      display: "flex", alignItems: "center", gap: 8,
    }}>
      <span style={{ color: colors[toast.type] || colors.info }}>
        {toast.type === "success" ? "✓" : toast.type === "error" ? "✕" : "ℹ"}
      </span>
      {toast.message}
    </div>
  );
}

function SocketInit() {
  useSocket(); // initializes socket globally
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login"    element={<AuthPage mode="login"    />} />
        <Route path="/register" element={<AuthPage mode="register" />} />
        <Route path="/*" element={
          <AuthGuard>
            <SocketInit />
            <AppShell />
          </AuthGuard>
        } />
      </Routes>
      <Toast />
    </BrowserRouter>
  );
}
